'use client';

var APPLY_MULTIPLE = 'api-gateway/v2.0/job/apply-multiple';
var MATCHING_JOB_URI = 'api-gateway/v1.0/profile/matching-job';

export { APPLY_MULTIPLE, MATCHING_JOB_URI };
//# sourceMappingURL=const.js.map
